import AlreadyAppliedDecline from '../../../pages/AlreadyAppliedDecline';
import InformationMismatch from '../../../pages/InformationMismatch';
import ScoreDecline from '../../../pages/ScoreDecline';
import { decisions } from '../../../utilities/constants';

const getResultPage = (decision: any, userData: any, requoteOptIn: any, isObDeclineConsent: any) => {
    switch (decision) {
        case decisions.INFORMATION_MISMATCH:
            return (
                <InformationMismatch
                    title={userData.title}
                    firstName={userData.firstName}
                    lastName={userData.lastName}
                    dateOfBirth={userData.dateOfBirth}
                    employmentStatus={userData.employmentStatus}
                    occupation={userData.occupation}
                    houseFlatNameNumber={userData.houseFlatNameNumber}
                    streetName={userData.streetName}
                    addressLine2={userData.addressLine2}
                    townCity={userData.townCity}
                    county={userData.county}
                    postcode={userData.postcode}
                    yearsAtAddress={userData.yearsAtAddress}
                />
            );

        case decisions.SCORE_DECLINE:
            return (
                <ScoreDecline
                    firstName={userData.firstName}
                    requoteOptIn={requoteOptIn}
                    isObDeclineConsent={isObDeclineConsent}
                />
            );

        case decisions.ALREADY_APPLIED_DECLINE:
            return <AlreadyAppliedDecline firstName={userData.firstName} />;

        default:
        case decisions.ERROR:
            throw new Error();
    }
};

export default getResultPage;
